// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__Ti_Jy","content":"LayoutSettings_content__YZzeC"};